/** Paket Etkin: sadece paket seviyesinde. false/0 dışındaki tüm değerler (null dahil) aktif sayılır. */
export const isPaketEtkin = (paket) => {
  const v = paket?.Etkin ?? paket?.PaketEtkin;
  return v !== false && v !== 0 && v !== "0";
};
